import api from './api';

/**
 * سرویس مدیریت فایل‌های مراجعان
 * شامل آپلود، دانلود و مدیریت فایل‌ها
 */

// دریافت لیست فایل‌های یک مراجع
export const getClientFiles = async (clientId) => {
  try {
    const response = await api.get(`/files/client/${clientId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// آپلود فایل جدید
export const uploadFile = async (clientId, fileData) => {
  try {
    const formData = new FormData();
    formData.append('file', fileData.file);
    formData.append('clientId', clientId);
    formData.append('customName', fileData.customName || '');
    formData.append('description', fileData.description || '');
    formData.append('public', fileData.public || false);

    const response = await api.post(`/files/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دانلود فایل
export const downloadFile = async (fileId) => {
  try {
    const response = await api.get(`/files/${fileId}`, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// حذف فایل
export const deleteFile = async (fileId) => {
  try {
    const response = await api.delete(`/files/${fileId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// بروزرسانی اطلاعات فایل
export const updateFile = async (fileId, fileData) => {
  try {
    const response = await api.put(`/files/${fileId}`, fileData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// آپلود فایل برای ملاقات (مشاوران)
export const uploadFileForAppointment = async (clientId, appointmentId, fileData) => {
  try {
    const formData = new FormData();
    formData.append('file', fileData.file);
    formData.append('clientId', clientId);
    formData.append('appointmentId', appointmentId);
    formData.append('customName', fileData.customName || '');
    formData.append('description', fileData.description || '');
    formData.append('public', fileData.public || false);

    const response = await api.post(`/files/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// آپلود فایل برای ملاقات (مدیران)
export const uploadFileForAppointmentAdmin = async (clientId, appointmentId, fileData) => {
  try {
    const formData = new FormData();
    formData.append('file', fileData.file);
    formData.append('clientId', clientId);
    formData.append('appointmentId', appointmentId);
    formData.append('customName', fileData.customName || '');
    formData.append('description', fileData.description || '');
    formData.append('public', fileData.public || false);

    const response = await api.post(`/files/admin/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
}; 